import { Component, OnInit } from '@angular/core';
import { MarkerService } from '../../../services/marker.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFireUploadTask, AngularFireStorageReference, AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators/';

import { finalize } from 'rxjs/operators';
import { MarkerModel } from 'src/app/models/marker.model';

declare var $: any;

@Component({
    selector: 'create-marker',
    templateUrl: './create-marker.component.html',
    styleUrls: ['./create-marker.component.scss']
})
export class CreateMarkerComponent implements OnInit {

    private basePath = '/images';
    error: any;

    constructor(private router: Router, private route: ActivatedRoute,
                public markersService: MarkerService, public storage: AngularFireStorage) {

    }

    marker: MarkerModel = new MarkerModel();
    markers: MarkerModel[] = [];
    uploadPercent: Observable<number>;
    downloadURL: Observable<string>;

    ngOnInit(): void {
        this.markersService.getItemsList().subscribe(
            (items) => {
                // tslint:disable-next-line: radix
                this.markers = items;
                this.marker.id = this.markers.sort(this.sortById)[0].id + 1;

            });
    }

    sortById(a, b) {
        if (a.id > b.id) {
            return -1;
        } else if (b.id > a.id) {
            return 1;
        } else {
            return 0;
        }
    }

    trackByIdx(index: number, obj: any): any {
        return index;
    }

    addCamera() {
        this.marker.cameras.push('Id rtsp.me');
    }

    deleteCamera(index) {
        this.marker.cameras.splice(index, 1);
    }

    addImage() {
        $('.image-upload-input-conainer').css('display', 'block');
    }

    validation() {
        this.error = undefined;

        if (!this.marker.name) {
            this.error = 'Введите название объекта';
        }

        if (!this.marker.pos.lat || this.marker.pos.lat === 0) {
            this.error = 'Введите широту объекта на карте';
        }

        if (!this.marker.pos.lng || this.marker.pos.lng === 0) {
            this.error = 'Введите долготу объекта на карте';
        }

        if (!this.marker.image) {
            this.error = 'Загрузите изображение объекта';
        }

        return !this.error;
    }

    createMarker() {

        if (!this.validation()) {
            return;
        }

        this.markersService.createMarker(this.marker).then(() => {
            this.returnToAdminPAge();
        });
    }

    returnToAdminPAge() {
        this.router.navigate(['admin']);
    }

    uploadFile(event) {
        const file = event.target.files[0];
        const filePath = `${this.basePath}/${file.name}`;
        const fileRef = this.storage.ref(filePath);
        const task = this.storage.upload(filePath, file);

        // observe percentage changes
        this.uploadPercent = task.percentageChanges();
        // get notified when the download URL is available
        task.snapshotChanges().pipe(
            finalize(() => {
                fileRef.getDownloadURL().subscribe((url) => {
                    this.marker.image = url;
                });

            })
        ).subscribe();
    }
}
